import { createActions } from 'redux-actions';

const { notification } = createActions({
  NOTIFICATION: {
    SEND_NOTIFICATION: notification => ({ notification }),
    SEND_NOTIFICATION_SUCCESS: () => undefined,
    SEND_NOTIFICATION_ERROR: error => error,
    REQUEST_NOTIFICATIONS_LIST: topicId => topicId,
    REQUEST_NOTIFICATIONS_LIST_ERROR: error => error,
    UPDATE_NOTIFICATIONS_LIST: notificationsList => notificationsList,
  },
});

export default notification;
